import { Environment, Region } from '@bringg/frontend-utils/dist/common/types';

const DEFAULT_REGION = 'default_region';

export default class RegionService {
	private readonly configuration: Environment;

	constructor(config: Environment) {
		this.configuration = config;
	}

	getConfigByRegion(): Region {
		const regionId = Number(this.getRegionFromUrl());
		const regionValues = this.configuration?.regions && Object.values(this.configuration.regions);

		return regionValues?.find(region => region['id'] === regionId) || this.getDefaultRegion();
	}

	private getDefaultRegion(): Region {
		return this.configuration.regions[this.configuration[DEFAULT_REGION]];
	}

	private getRegionFromUrl() {
		const urlParams = new URLSearchParams(window.location.hash);

		if (urlParams) {
			return urlParams.get('e');
		}
	}
}
